import React from 'react'
import { StackView } from '@planningcenter/tapestry-react'
import {
  PageHeading,
  Heading,
  Text,
  List,
  Code,
  Link,
} from '../../shared/typography'

const page = () => {
  return (
    <StackView axis="vertical" spacing={2}>
      <PageHeading>Versioning</PageHeading>

      <Text>
        The Planning Center API supports versioning on a per-application basis.
      </Text>

      <Text>There are 2 ways to specify a version:</Text>

      <List ordered>
        <List.Item>
          Setting a per-app default{' '}
          <Link to="https://api.planningcenteronline.com" external>
            here
          </Link>
        </List.Item>
        <List.Item>
          Passing a header on every request: <Code>X-PCO-API-Version</Code> with
          a value of <Code>YYYY-MM-DD</Code>
        </List.Item>
      </List>

      <Text>Versions are resolved in this order</Text>

      <List>
        <List.Item>First: Request header specified version number</List.Item>
        <List.Item>Second: Per-App default version number</List.Item>
      </List>

      <Text>
        You can use both of these methods together. For example, you can set a
        per-app version, and if needed, override that with a header for any
        single request.
      </Text>

      <Heading anchored id="version-matching">Version Matching</Heading>

      <Text>
        Version numbers are matched to a version using a equal-to-or-less-than
        algorithm.
      </Text>

      <Text>
        For example: Given available versions of <Code>2018-08-01</Code>,{' '}
        <Code>2018-08-10</Code>, &amp; <Code>2018-08-17</Code>. Passing a
        version header of <Code>X-PCO-API-Version: 2018-08-14</Code> will
        process the request using version <Code>2018-08-10</Code>.
      </Text>

      <Heading anchored id="using-latest">
        Using <Code>LATEST</Code>
      </Heading>

      <Text>
        If you want to be on the cutting edge (not recommended for production
        applications). You can pass <Code>X-PCO-API-Version: LATEST</Code>.
        Under the hood this is equivalent to always passing tomorrows date.
        Expect there to be breaking changes between versions.
      </Text>

      <Heading anchored id="versions-prior-to-2018-08-01">
        Versions Prior to <Code>2018-08-01</Code>
      </Heading>

      <Text>
        If you specify a version before the default version{' '}
        <Code>2018-08-01</Code> you will get a <Code>HTTP 400</Code> status code
        and an error code of <Code>unsupported_version_error</Code>.
      </Text>
    </StackView>
  )
}

export default page
